<template>
  <div>
    <div v-if="summaryInfo" class="row">
      <div class="col-md-4">
        <div class="row">
          <div class="col-md-8">
            <div class="row">
              <div class="col-md-12">
                <h2 v-if="summaryInfo.reviewTitle === 'Suitability Review'"
                    class="h5 fw-semibold mb-1">
                  {{ summaryInfo.reviewTitle }} Score
                </h2>
                <h2 v-else class="h5 fw-semibold mb-1">
                  {{ summaryInfo.reviewTitle }} Review score
                </h2>

                <p class="text-muted small mb-2">
                  Assessing, matching, evaluating, suitability criteria, client needs.
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <i v-if="issetIncomplete" class="fa fa-spinner fa-spin"></i>

            <CircularProgress
                v-else
                :percentage="summaryInfo.scorePercentage"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <h2 v-if="summaryInfo.reviewTitle === 'Suitability Review'" class="h5 fw-semibold">
              {{ summaryInfo.reviewTitle }}
            </h2>
            <h2 v-else class="h5 fw-semibold">
              {{ summaryInfo.reviewTitle }} Review
            </h2>

            <template v-for="item in summaryInfo.mainSections">
              <div v-if="item.visible" class="row">

                <div class="col-md-10 text-muted small item-title-score">
                  {{ item.title }}
                </div>


                <div class="col-md-2">
                  <div class="score-percentage" :style="getScoreStyle(item.percentage)">
                    {{ item.percentage * 10 }} %
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="col-md-8">
        <div v-if="issetIncomplete">
          <i class="fa fa-spinner fa-spin"></i>
        </div>
        <div v-else>
          <h2 class="h5 fw-semibold">Summary AI generated</h2>
          <p class="summary-ai-generated" v-html="summaryInfo.summaryAiGenerated"></p>
        </div>
      </div>

      <div class="col-md-12">
        <hr>
      </div>
    </div>
    <div style="clear:both;"></div>


    <div class="row">
      <div class="col-md-12">
        <div class="page-breadcrumbs">
          <a href="/documents" class="dashboard-action-t">Document Library</a>
          <span class="dashboard-action-t"> / </span>
          <template v-if="typeName">
            <span class="dashboard-action-t">{{ typeName }}</span>
            <span class="dashboard-action-t"> / </span>
          </template>
          <a href="#" class="dashboard-action-t-active">{{document.name}}</a>
        </div>
      </div>

      <div id="file-info" class="col-md-6">
        <div class="row">
          <div class="col-md-4">
            <p style="word-break: break-all;"><b>{{document.name}}</b></p>
          </div>
          <div class="col-md-5">
            <p>Uploaded: {{ formatDate(document.created_at) }}</p>
          </div>
          <div class="col-md-3">
            <a class="document-link" :href="'/documents/download/' + id">
              Download file &nbsp;&nbsp;<i class="fa fa-download"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div v-if="issetIncomplete" class="col-md-12">
            <button class="btn btn-default btn-small pull-right" disabled style="background-color: #81818126; color: rgb(141 135 135);">PROCESSING <i v-if="issetIncomplete" class="fa fa-spinner fa-spin"></i></button>
          </div>
          <div v-else class="col-md-12">
            <a target="_blank" :href="downloadUrl" class="btn btn-default btn-primary btn-small pull-right">Download PDF</a>
          </div>

          <div class="col-md-12">
            <button class="btn btn-default btn-primary btn-small pull-right" v-on:click="newAuditData()">REFRESH AUDIT</button>
          </div>

        </div>
      </div>
    </div>
    <div class="row">

      <div class="col-md-12" v-for="item in items" id="document-results-table-block">
        <div v-if="item.displayConditionQuestionParent">
          {{ formatDisplayConditionQuestion(item.displayConditionQuestionParent) }}
          <div>
            <label>
              <input
                  type="checkbox"
                  :name="'toggle-' + item.displayConditionQuestionParent"
                  v-model="item.displayConditionQuestionParentVisible"
                  @change="updateVisible(document.id, item.reportSection, 'parent', item.displayConditionQuestionParentVisible)" /> Yes
            </label>
          </div>
        </div>
        <div v-if="!item.displayConditionQuestionParent || item.displayConditionQuestionParentVisible">
          <h5>{{item.reportSection}}</h5>
          <div>
            <table class="table table-striped table-borderless">
              <thead class="">
              <tr>
                <th class="text-center" width="25%">Report Requirements</th>
                <th class="text-center" width="25%">Regulatory reference</th>
                <th class="text-center" width="50%">Rating</th>
              </tr>
              </thead>
              <tbody>

              <tr v-for="requirement in item.reportRequirements">
                <td width="25%" v-html="requirement.name"></td>
                <td width="25%">
                  <template v-if="requirement.rrc.length > 0">
                    <template v-for="rrc in requirement.rrc"><a :href="rrc.link" target="_blank">{{rrc.text}}</a><br></template>
                  </template>
                  <template v-if="requirement.mifid.length > 0">
                    MiFID: <template v-for="mifid in requirement.mifid"><a :href="mifid.link" target="_blank">{{mifid.text}}</a><br></template>
                  </template>
                  <template v-if="requirement.nonMifid.length > 0">
                    Non-MiFID: <template v-for="nonMifid in requirement.nonMifid"><a :href="nonMifid.link" target="_blank">{{nonMifid.text}}</a><br></template>
                  </template>
                  <template v-if="requirement.consumerDuty.length > 0">
                    Consumer Duty: <template v-for="consumerDuty in requirement.consumerDuty"><a :href="consumerDuty.link" target="_blank">{{consumerDuty.text}}</a><br></template>
                  </template>
                </td>
                <td width="50%">
              <span v-if="requirement.status === 0">
                <i class="fa fa-spinner fa-spin"></i>
              </span>

                  <span v-if="requirement.status === 2">
                <button class="btn btn-primary btn-small" v-on:click="reloadItemAuditData(requirement)">Refresh item</button>
              </span>

                  <div style="clear: both"></div>
                  <div v-if="requirement.contentGuidanceAi" style="display: flex;">
                    <div class="score" v-bind:style="getScoreStyle(requirement.score)">

                        <svg v-if="requirement.score < 4" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="4.5" stroke-linecap="round" stroke-linejoin="round">
                          <line x1="6" y1="6" x2="18" y2="18" />
                          <line x1="6" y1="18" x2="18" y2="6" />
                        </svg>

                        <svg v-if="requirement.score > 3 && requirement.score < 8" xmlns="http://www.w3.org/2000/svg" class="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round">
                          <line x1="12" y1="6" x2="12" y2="14" />
                          <circle cx="12" cy="18" r="1.7" fill="currentColor" stroke="none" />
                        </svg>

                        <svg v-if="requirement.score > 7" xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">
                          <path d="M5 12.5l4 4L19 7.5" />
                        </svg>

                    </div>
                    <p style="width: 100%; margin-left: 10px;">{{requirement.contentGuidanceAi}}</p>
                  </div>
                  <button v-if="requirement.status === 1 && requirement.contentGoodPractice" class="btn btn-link btn-small pull-right" v-on:click="showGoodPracticeModal(requirement.contentGoodPractice)">Good Practice</button>
                  <button v-if="requirement.status === 1" class="btn btn-link btn-small pull-right" v-on:click="showGuidanceModal(requirement)">More info</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <vue-final-modal
          modal-id="show-guidance"
          class="modal--container modal-shadow"
          content-class="modal--content"
          :content-style="{height: 'auto'}"
          height="auto">
        <div class="guidance-modal-content">
          <div class="card-title">MO® guidance</div>
          <div v-html="showGuidance"></div>
          <br/>
          <button class="btn btn-default btn-primary btn-small pull-right" v-on:click="closeModalGuidance('show-guidance')">Close</button>
          <br>
          <br>
          <hr>
          <div class="row row-comment" v-for="item in currentDocumentResult.notes">
            <div class="col-md-8 card-title card-title-300">
              {{ item.note }}
            </div>
            <div class="col-md-4 card-title card-title-300">
              <span v-if="item.user.account_role==='auditor'" class="auditor-pill">Auditor<br /></span>{{item.user.first_name}} {{item.user.last_name}}<br />
              {{ formatDate(item.created_at, item.updated_at) }}
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <a class="add-note" v-on:click.prevent.stop="showNoteModal($event)">
                <i class="fa fa-plus"></i>
                Add Note
              </a>
            </div>
          </div>
        </div>
      </vue-final-modal>

      <vue-final-modal
          modal-id="show-good_practice"
          class="modal--container modal-shadow"
          content-class="modal--content"
          :content-style="{height: 'auto'}"
          height="auto">
        <div class="good-practice-modal-content">
          <div class="card-title"></div>
          <div v-html="showGoodPractice"></div>
          <br/>
          <button class="btn btn-default btn-primary btn-small pull-right" v-on:click="closeModalGoodPractice('show-good_practice')">Close</button>
        </div>
      </vue-final-modal>

      <vue-final-modal
          modal-id="add-note"
          class="modal--container modal-shadow"
          content-class="modal--content"
          :content-style="{height: 'auto'}"
          height="auto">
        <div class="document-result-modal-content">
          <div class="card-title">Add Notes:</div>
          <div class="card-subtitle">e.g. Follow on actions, delegated or handover, date resolved, date completed and reported</div>
          <br/>
          <textarea class="notice-textarea" maxlength="500" v-on:input="setNote($event)"></textarea>
          <p class="notice-textarea-warning">{{ noticeLengthWarning }}</p>
          <br/>
          <button class="btn btn-default btn-primary btn-small" v-on:click="sendData('add-note','add-note')">
            Add note
          </button>
        </div>
      </vue-final-modal>

    </div>
  </div>
</template>

<script>

import { VueFinalModal, ModalsContainer } from 'vue-final-modal'
import CircularProgress from "./ui/CircularProgress.vue";

export default {
  name: "DocumentViewComponent",
  props: ['id', 'downloadUrl', 'typeSlug'],
  components: {
    CircularProgress,
    VueFinalModal,
    ModalsContainer,
  },
  data() {
    return {
      document: {},
      summaryInfo: {},
      items: [],
      showGuidance: null,
      showGoodPractice: null,
      currentNote: null,
      currentDocumentResult: null,
      noticeLengthWarning: null,
      csrf: null,
      autoRefreshCount: 0,
      typeName: null,
      issetIncomplete: true,
    }
  },
  computed: {

  },
  methods: {
    getDocumentAuditData(id = null) {
      axios.get(
          `/monitor/audit-data/${this.id}`
      ).then(res => {
        this.items = res.data.documentAuditData;
        this.document = res.data.document;
        this.summaryInfo = res.data.summaryInfo;

        if(res.data.issetIncomplete) {
          this.issetIncomplete = res.data.issetIncomplete;
          this.startAutoRefresh();
        } else {
          this.issetIncomplete = false;
        }

        if (id) {
          this.currentDocumentResult = this.items.flatMap(section => section.reportRequirements).find(requirement => requirement.id === id);
        }

      }).catch(err => {
        console.error(err)
      })
    },
    newAuditData() {
      axios.get(
          `/monitor/new-audit-data/${this.id}`
      ).then(res => {
        this.getDocumentAuditData();
      }).catch(err => {
        console.error(err)
      })
    },
    reloadItemAuditData(item) {
      axios.get(
          `/monitor/reload-item-audit-data/${item.id}`
      ).then(res => {
        this.getDocumentAuditData();
      }).catch(err => {
        console.error(err)
      })
    },
    startAutoRefresh() {
      setTimeout(() => {
        this.getDocumentAuditData();
      }, 2000);
    },
    showGuidanceModal: function (documentResult) {
      this.showGuidance = documentResult.contentGuidance;
      this.currentDocumentResult = documentResult;
      this.$vfm.open("show-guidance");
    },
    closeModalGuidance: function (modalName) {
      this.showGuidance = null;
      this.$vfm.close(modalName);
    },
    showGoodPracticeModal: function (goodPractice) {
      this.showGoodPractice = goodPractice;
      this.$vfm.open("show-good_practice");
    },
    closeModalGoodPractice: function (modalName) {
      this.showGoodPractice = null;
      this.$vfm.close(modalName);
    },
    showNoteModal: function (event) {
      event.preventDefault();
      this.$vfm.open("add-note");
    },
    setNote: function (event) {
      this.currentNote = event.target.value;
      if (this.currentNote.length == 500) {
        this.noticeLengthWarning =
            "You have exceeded the maximum number of characters. Must not exceed 500 characters.";
        event.preventDefault();
        return;
      }
    },

    sendData: function (action, modalName) {
      self = this;
      let id = this.currentDocumentResult.id;
      this.$vfm.close(modalName);

      axios
          .post("/monitor/api/" + id, {
            action: action,
            note: this.currentNote,
            user_id: this.currentUserId,
          })
          .then(function (response) {
            self.getDocumentAuditData(id);
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    updateVisible: function (documentId, sectionName, visible, value) {
      let params = {
        action: 'update-visible',
        value: value,
        visible: visible,
        section_name: sectionName,
      };

      axios
          .post(`/monitor/api/${documentId}`, params)
          .then(() => {
            this.getDocumentAuditData(documentId);
          })
          .catch(function (error) {
            console.log(error);
          });
    },

    formatDisplayConditionQuestion: function (text) {
      if (!text) {
        return text;
      }

      return text.replace(/\s*Y\/N\s*If\s*Y\s*show\s*this\s*section\s*If\s*N\s*do\s*not\s*show\s*or\s*score\s*this\s*section\.?/i, '').trim();
    },
    getScoreStyle: function (score) {
      let color = '#2ECC71';
      let border = 'transparent';
      if (score < 4) {
        color = '#DE301D';
      } else if (score < 8) {
        color = '#F1C40F';
      }

      return {
        backgroundColor: color,
        borderColor: border
      };
    },
    formatDate: function (created_at, updated_at) {
      let date = null;
      if (created_at || updated_at) {
        if (created_at) {
          date = created_at;
        } else {
          date = updated_at;
        }
        date = moment(date, "YYYY-MM-DD h:imm:ss").format("DD.MM.YYYY  HH:mm:ss");
      }

      return date;
    },
  },
  mounted() {
    this.csrf = document.querySelector('meta[name="csrf-token"]').content;
  },
  created() {
    this.getDocumentAuditData();
    axios.get('/monitor/document-types').then(res => {
      this.typeName = (res.data.find(type => type.type_name_slug === this.typeSlug) || {}).type_name;
    });
  },
  beforeDestroy() {
    clearInterval(this.refreshInterval);
  }
}
</script>

<style scoped>
 .custom_thead {
   /*background-color: #73C2AF;*/
 }
 .custom_thead tr th {
   /*color: #fff;*/
 }
 .guidance-modal-content,
 .good-practice-modal-content,
 .document-result-modal-content {
   padding: 50px;
   overflow-y: scroll;
   height: 500px;
 }
 .score {
   color: #ffffff;
   width: 20px;
   height: 20px;
   font-size: 0.9em;
   border-radius: 100%;
   border: 2px solid;
   display: flex;
   align-items: center;
   justify-content: center;
 }
 body.document .add-note {
   margin-top: 0;
   margin-bottom: 20px;
 }
 .score-percentage {
   width: 40px;
   height: 40px;
   font-size: 0.8em;
   border-radius: 100%;
   border: 2px solid;
   display: flex;
   align-items: center;
   justify-content: center;
   text-align: center;
   color: black;
   margin: 5px;
 }
 .item-title-score {
    margin: 10px auto;
 }
 .summary-ai-generated {
   padding: 10px;
 }
</style>